(($, window) => {


    class BLVCRedemption {

        constructor(el) {

            this.screenEl = el;
            this.vcode = el.data('vcode');
            this.ecpID = el.data('ecp-id');
            this.navLock = false;

            this.screens = {
                
                verifyECP: {
                    template: `<div><h2>${BLVC_AJAX_TEXTS['txt-ajx-is-ecp']}</h2>
                    <p>${BLVC_AJAX_TEXTS['txt-ajx-is-ecp-detail']}</p>
                    <div class="buttons">
                        <a href="#" class="is-ecp" data-screen="verifyECPAddress">${BLVC_AJAX_TEXTS['txt-ajx-yes']}</a>
                        <a href="#" data-screen="noECP">${BLVC_AJAX_TEXTS['txt-ajx-no']}</a>
                    </div></div>`,
                    onLoad: el => {
                        
                        // If no ECP nominated for this voucher, suggest manually set ECP if cookie set, otherwise go directly to search
                        
                        if(!this.ecpID) {
                            const manualECPID = Cookies.get('manual_ecp_id');
                            if (manualECPID !== undefined && !isNaN(manualECPID) && manualECPID != this.ecpID) {
                                el.find('a.is-ecp').data('screen', 'verifyECPAddressByCookie');
                            }
                            else {
                                el.find('a.is-ecp').data('screen', 'findECP');
                            }
                        }
                    }
                },

                noECP: {
                    template: `<div><h2>${BLVC_AJAX_TEXTS['txt-ajx-not-ecp']}</h2>
                    <p class="next-steps">${BLVC_AJAX_TEXTS['txt-ajx-not-ecp-detail']}</p>
                    <div class="ecp-address"></div></div>`,
                    onLoad: el => {

                        if (!this.ecpID) {
                            el.find('.next-steps').empty().append(
                                $('<a/>')
                                    .text(BLVC_AJAX_TEXTS['txt-ajx-find-an-ecp'])
                                    .attr('href', '/find-an-optician/')
                                    .addClass('preserve-link chevron_plain')
                            );
                        }
                        
                        BLVCPublicAjaxAction
                            .post('get_ECP_by_ID', {
                                ID: this.ecpID
                            })
                            .then(data => {
                                el
                                    .find('.ecp-address')
                                    .append(`<strong>${data.title}</strong><br>${data.address.formatted}`);
                            });
                    }
                },

                verifyECPAddress: {
                    template: `<div><h2>${BLVC_AJAX_TEXTS['txt-ajx-is-ecp-address']}</h2>
                    <div class="ecp-address"></div>
                    <div class="buttons">
                        <a href="#" data-screen="redemptionSuccess">${BLVC_AJAX_TEXTS['txt-ajx-yes']}</a>
                        <a href="#" class="findECP" data-screen="findECP">${BLVC_AJAX_TEXTS['txt-ajx-no']}</a>
                    </div></div>`,
                    onLoad: el => {
                        
                        BLVCPublicAjaxAction
                            .post('get_ECP_by_ID', {
                                ID: this.ecpID
                            })
                            .then(data => {
                                el
                                    .find('.ecp-address')
                                    .append(`<strong>${data.title}</strong><br>${data.address.formatted}`);
                            });

                        const manualECPID = Cookies.get('manual_ecp_id');
                        if (manualECPID !== undefined && !isNaN(manualECPID) && manualECPID != this.ecpID) {
                            el.find('a.findECP').data('screen', 'verifyECPAddressByCookie');
                        }
                    }
                },

                verifyECPAddressByCookie: {
                    template: `<div><h2>${BLVC_AJAX_TEXTS['txt-ajx-is-ecp-address']}</h2>
                    <div class="ecp-address"></div>
                    <div class="buttons">
                        <a href="#" data-screen="redemptionSuccess">${BLVC_AJAX_TEXTS['txt-ajx-yes']}</a>
                        <a href="#" data-screen="findECP">${BLVC_AJAX_TEXTS['txt-ajx-no']}</a>
                    </div></div>`,
                    onLoad: el => {
                        const manualECPID = Cookies.get('manual_ecp_id');
                        if (manualECPID !== undefined && !isNaN(manualECPID)) {
                            this.ecpID = manualECPID;

                            BLVCPublicAjaxAction
                                .post('get_ECP_by_ID', {
                                    ID: this.ecpID
                                })
                                .then(data => {
                                    el
                                        .find('.ecp-address')
                                        .append(`<strong>${data.title}</strong><br>${data.address.formatted}`);
                                });
                        }
                    }
                },

                findECP: {
                    template: `<div><h2>${BLVC_AJAX_TEXTS['txt-ajx-postcode-prompt']}</h2>
                    <form method="post" action="">
                        <input type="text" name="postcode" placeholder="${BLVC_AJAX_TEXTS['txt-ajx-postcode-placeholder']}" required>
                        <input type="submit" name="submit" value="${BLVC_AJAX_TEXTS['txt-ajx-search-button']}">
                    </form>
                    <div class="ecp-results"></div></div>"`,
                    onLoad: el => {
                        let searchForm = el.find('form');
                        searchForm.first().submit(e => {
                            e.preventDefault();

                            BLVCPublicAjaxAction
                                .post('get_ECPs_by_search', {
                                    postcode: searchForm.find('input[name="postcode"]').val()
                                })
                                .then(data => {
                                    let resultsArea = el.find('.ecp-results');
                                    resultsArea.empty();

                                    if (!data.length) {
                                        resultsArea.append(`<h3>${BLVC_AJAX_TEXTS['txt-ajx-no-results']}</h3>`);
                                    }
                                    else {
                                        
                                        resultsArea.append(`<h3>${BLVC_AJAX_TEXTS['txt-ajx-ecp-select-prompt']}</h3>`);
                                        resultsArea.append(
                                            data
                                                .map(ecp => `<a href="#" data-ecp-id="${ecp.ID}"><strong>${ecp.title}</strong> ${JSON.parse(ecp.location_address).formatted}</a>`)
                                                .join('')
                                        );

                                        resultsArea.find('a').on('click', e => {
                                            e.preventDefault();
                                            this.ecpID = $(e.currentTarget).data('ecp-id');
                                            this.displayScreen('verifyECPAddress');
                                        });
                                    }
                                });
                        });
                    }
                },

                redemptionSuccess: {
                    template: `<div><h2>${BLVC_AJAX_TEXTS['txt-ajx-redemption-success']} <span class="voucher-code">${this.vcode}</span></h2>
                    <p>${BLVC_AJAX_TEXTS['txt-ajx-trial-prompt']}</p>
                    <div class="trial-details"></div></div>"`,
                    onLoad: el => {

                        Cookies.set('manual_ecp_id', this.ecpID, { expires: 200 });

                        BLVCPublicAjaxAction
                            .post('redeem_voucher', {
                                vcode: this.vcode,
                                ecpID: this.ecpID
                            })
                            .then(data => {
                                if (data != 1) {
                                    console.log('Error #5');
                                }
                            });

                        BLVCPublicAjaxAction
                            .post('get_user_by_vcode', {
                                vcode: this.vcode
                            })
                            .then(data => {
                                el.find('.trial-details').append(
                                    `${data.first_name} ${data.surname}<br>
                                    ${data.email}<br>
                                    ${data.mobile_number}`
                                )
                            });
                    }
                }
            }
    
            this.displayScreen('verifyECP');
        }

        displayScreen(screenID) {

            if (this.navLock) {
                return;
            }

            this.navLock = true;
            
            if (typeof this.screens[screenID] !== 'object') {
                console.log('invalid screen');
                return;
            }

            let template = $(this.screens[screenID].template);

            if (typeof this.screens[screenID].onLoad == 'function') {
                this.screens[screenID].onLoad(template);
            }

            template.find('a').not('.preserve-link').on('click', e => {
                e.preventDefault();
                const destinationScreen = $(e.currentTarget).data('screen');
                
                if (destinationScreen) {
                    this.displayScreen(destinationScreen);
                }
            });

            if (this.screenEl.is(':empty')){
                this.revealScreen(template);
            }
            else {
                gsap.to(this.screenEl.find('> div > *'), {
                    duration: 0.5,
                    y: -10,
                    opacity: 0,
                    ease: 'power3.inOut',
                    stagger: 0.1,
                    onComplete: () => {
                        this.screenEl.empty();
                        this.revealScreen(template);
                    }
                });
                
            }

        }

        revealScreen(template) {
            this.screenEl.append(template);
            gsap.from(this.screenEl.find('> div > *'), {
                duration: 0.5,
                y: 10,
                opacity: 0,
                ease: 'power3.inOut',
                stagger: 0.1,
                onComplete: () => {
                    this.navLock = false;
                }
            });
        }
    }

    window.BLVCRedemption = BLVCRedemption;

})(jQuery, window);
